import { render } from "./Connect.vue?vue&type=template&id=5e24a638&scoped=true"
import script from "./Connect.vue?vue&type=script&setup=true&lang=js"
export * from "./Connect.vue?vue&type=script&setup=true&lang=js"

import "./Connect.vue?vue&type=style&index=0&id=5e24a638&scoped=true&lang=css"

import exportComponent from "/home/runner/work/channel-xyz/channel-xyz/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e24a638"],['__file',"src/components/Wallet/Connect.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e24a638"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e24a638', __exports__)) {
    api.reload('5e24a638', __exports__)
  }
  
  module.hot.accept("./Connect.vue?vue&type=template&id=5e24a638&scoped=true", () => {
    api.rerender('5e24a638', render)
  })

}


export default __exports__